import { Navigate, type RouteObject } from "react-router-dom";
import { StaffShell } from "@/nav/StaffShell";
import { RequireAuth } from "./guards";
import { legacyRoutes } from "./legacy";
import { publicRoutes } from "@/areas/public/routes";
import { homeRoutes } from "@/areas/home/routes";
import { waterRoutes } from "@/areas/water/routes";
import { fleetRoutes } from "@/areas/fleet/routes";
import { peopleRoutes } from "@/areas/people/routes";
import { supportRoutes } from "@/areas/support/routes";
import { appsRoutes } from "@/areas/apps/routes";
import { adminRoutes } from "@/areas/admin/routes";

export const appRoutes: RouteObject[] = [
  ...publicRoutes,
  {
    id: "staff",
    element: <RequireAuth><StaffShell /></RequireAuth>,
    children: [
      ...homeRoutes,
      ...waterRoutes,
      ...fleetRoutes,
      ...peopleRoutes,
      ...supportRoutes,
      ...appsRoutes,
      ...adminRoutes,
      ...legacyRoutes,
      { id: "catch-all", path: "*", element: <Navigate to="/" replace /> },
    ],
  },
];
